<input
  (ngModelChange)="model && (model.id = $event)"
  (selectItem)="onSelected($event)"
  [disabled]="readonly"
  [inputFormatter]="inputFormatter"
  [ngbTypeahead]="search"
  [ngModel]="model && model.id"
  [placeholder]="'GemeindeAuswahl' | translate"
  [resultFormatter]="resultFormatter"
  class="form-control form-control-component mt-2"
  type="search" />
@if (showNoResultText) {
  <div class="dropdown-menu show">
    <button (click)="onClear()" class="dropdown-item">{{ "search.noResults" | translate }}</button>
  </div>
}

@if (gemeinden.size > 0) {
  <div class="mt-2" style="max-height: 250px; overflow: auto">
    <table class="cap-table-detail">
      <thead>
        <tr>
          <th style="width: 100%">
            {{ "Gemeinden" | translate }}
          </th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        @for (gemeinde of gemeinden; track gemeinde; let i = $index) {
          <tr>
            <td class="noselect">{{ gemeinde.name | translateName }} {{ gemeinde.bfsNummer }}</td>
            <td>
              <button
                (click)="onDelete(gemeinde)"
                [disabled]="readonly"
                [ngbTooltip]="'GemeindeEntfernen' | translate"
                class="btn btn-danger btn-sm deleteButton"
                placement="left"
                type="button">
                <i class="fas fa-trash"></i>
              </button>
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>
}
